import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { TableSettingsComponent } from './table-settings.component';

@NgModule({
  declarations: [TableSettingsComponent],
  exports: [TableSettingsComponent],
  imports: [CommonModule, NgbDropdownModule],
})
export class TableSettingsModule {}
